/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ category: NonNullable<unknown> }} Cookie_Frame_ActionInputs */

const en_cookie_frame_action = /** @type {(inputs: Cookie_Frame_ActionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enable ${i?.category} consent`)
};

const lv_cookie_frame_action = /** @type {(inputs: Cookie_Frame_ActionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Atļaut sīkdatnes kategorijā “${i?.category}”`)
};

/**
* | output |
* | --- |
* | "Enable {category} consent" |
*
* @param {Cookie_Frame_ActionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cookie_frame_action = /** @type {((inputs: Cookie_Frame_ActionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Frame_ActionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cookie_frame_action(inputs)
	return en_cookie_frame_action(inputs)
});